import Menu from "./menu";
import Services from "./services";
import Book from "./book";
import Rooms from "./rooms";
import Mediateur from "./Mediateur"
import Mentions from "./Mentions"
import Annulation from "./Annulation"

import img1 from "../images/img1.jpg";
import img3 from "../images/img3.jpg";
import pmr from "../images/pmr.jpeg";
import img2 from "../images/img2.jpg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMapMarkerAlt, faPhoneAlt, faEnvelope, faPersonCircleExclamation} from "@fortawesome/free-solid-svg-icons";
import Review from "./review";
import {useState} from "react";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './App.css';

function App() {
    const { t } = useTranslation();

    const [room, setRoom] = useState('')
    const [open, setOpen] = useState(false)
    const [openMentions, setOpenMentions] = useState(false)
    const [openAnnulation, setOpenAnnulation] = useState(false)
    function handleChange(e) {
        setRoom(e)
    }

   const roomsData = [
    {
      image: img1,
      titleKey: "rooms.double.title",
      bedSizeKey: "rooms.bedSizes.double",
      features: [
        t("rooms.double.features.ideal"),
        t("rooms.double.features.wifi"),
        t("rooms.double.features.breakfast"),
      ],
      rate: 64,
    },
    {
      image: img3,
      titleKey: "rooms.twin.title",
      bedSizeKey: "rooms.bedSizes.twin",
      features: [
        t("rooms.twin.features.ideal"),
        t("rooms.twin.features.wifi"),
        t("rooms.twin.features.breakfast"),
      ],
      rate: 66,
    },
    {
      image: pmr,
      titleKey: "rooms.accessibility.title",
      bedSizeKey: "rooms.bedSizes.accessibility",
      features: [
        t("rooms.accessibility.features.ideal"),
        t("rooms.accessibility.features.wifi"),
        t("rooms.accessibility.features.breakfast"),
      ],
      rate: 66,
    },
    {
      image: img2,
      titleKey: "rooms.family.title",
      bedSizeKey: "rooms.bedSizes.family",
      features: [
        t("rooms.family.features.ideal"),
        t("rooms.family.features.wifi"),
        t("rooms.family.features.breakfast"),
      ],
      rate: 99,
    },
  ];

  return (
    <div className="App">
      <header className="header" id="header">
        <div className="head-top">
          <div className="site-name">
          <a href="/">
              <span>Hotel du marais</span>
            </a>
          </div>
          
          <div className="center-language-switcher">
            <LanguageSwitcher />
          </div>
          
          <Menu />
        </div>

        <div className="head-bottom flex">
          <h2>{t('header.title')}</h2>
          <p>{t('header.description')}
            <br /><br /> {t('header.description2')} <br />
              <br /> {t('header.description3')} <br />

                <br /> {t('header.description4')}
                  <br />

                    <br /> {t('header.description5')}
                      <br />

                        <br /> {t('header.description6')}</p>
          <a className="head-btn" href="#book">{t('header.reserveButton')}</a>
        </div>
      </header>

      <Services />
      <Book roomsData={roomsData} selectedRoom={room} setSelectedRoom={handleChange}/>
      <Rooms roomsData={roomsData} roomSetter={handleChange}/>

        <Review />
      <footer className= "footer">
        <div className= "footer-container">
          <div>
            <h2>{t('footer.about')}</h2>
            <p>{t('footer.taxInfo')}</p>
            <p>{t('footer.reviewsDisclaimer')} <a href="mailto:lhotelromilly@gmail.com">lhotelromilly@gmail.com</a> ou par telephone au <a href="tel:+33325252510">03 25 25 25 10</a>
            </p> <br /> <br />


            <p>{t('footer.designCredit')} <a href="https://github.com/prabinmagar/hotel-gp-single-page-site">  prabinmagar</a></p>
            <div  >
            <span><a href="" onClick={(event) =>{ event.preventDefault(); setOpenMentions(true);}} >{t('footer.legalMentions')}</a>
            <Mentions open={openMentions} setOpen={setOpenMentions}></Mentions>
            </span>
        </div>
        <div >
            <span><a href="" onClick={(event) =>{ event.preventDefault(); setOpenAnnulation(true);}} >{t('footer.reservationConditions')}</a>
            <Annulation open={openAnnulation} setOpen={setOpenAnnulation}></Annulation>
            </span>
        </div>

    </div>


    <div>
      <h2>{t('footer.question')}</h2>
      <div className= "contact-item">
                          <span>
                              <FontAwesomeIcon icon={faMapMarkerAlt} />
                          </span>
        <span>
                              <a href="https://goo.gl/maps/W1bC9cLYEvZA8teC7">123 Av. Diderot, 10100 Romilly-sur-Seine </a>
                          </span>
      </div>
      <div className= "contact-item">
                          <span>
                              <FontAwesomeIcon icon={faPhoneAlt} />
                          </span>
        <span>
                              <a href="tel:+33325252510">03 25 25 25 10</a>
                          </span>
      </div>
      <div className= "contact-item">
                          <span>
                              <FontAwesomeIcon icon={faEnvelope} />
                          </span>
        <span>
                              <a href="mailto:lhotelromilly@gmail.com">lhotelromilly@gmail.com</a>
                          </span>
      </div>
        <div className={"contact-item"} >
            <span><FontAwesomeIcon icon={faPersonCircleExclamation} /></span>
            <span><a href="" onClick={(event) =>{ event.preventDefault(); setOpen(true);}} > {t('footer.mediator')} </a>
            <Mediateur open={open} setOpen={setOpen}></Mediateur>
            </span>
        </div>
        
        <div className="footer-language-switcher">
            <LanguageSwitcher />
        </div>
      
    </div>
</div>
</footer>
    </div>
  );
}

export default App;